<script>
import { masterMethods, employeeMethods, settingPhoneMethods, authFackMethods } from '@/state/helpers';
import { checkPermission, checkPermissionName } from '@/utils/handlers';
import { keyMaster, ID_ROLE_FIXED, PHONE_SETTING_EMPLOYEE, NAMEROLEFIXED } from '@/config/constants';
import { showMessage } from '@/utils/messages.js';
import { InputCheckBox, InputText, InputRadio } from '@/components/Input';
import { state } from '@/state/modules/authfack.js';
import { initForm, ROLE_OPTIONS, AUTHORITY_OPTIONS, STATUS_OPTIONS, configFormEmployee } from '@/views/pages/employee/form/index.js';
import { validateAllField, validateField } from '@/utils/validate_v2';
import { cleanConfigFormData } from '@/utils/format';

import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import LoadingIcon from '@/components/Loading/main.vue';
import Footer from '@/components/Footer/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

export default {
    page: {
        title: 'パルディア社員新規登録',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        LoadingIcon,
        Layout,
        Footer,
        InputCheckBox,
        InputRadio,
        InputText,
        Multiselect
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.id) {
            if (!checkPermission('employee.edit')) {
                next({ name: 'errorPage' });
            }
            next();
        } else {
            if (!checkPermission('employee.register')) {
                next({ name: 'errorPage' });
            }
            next();
        }
    },
    data() {
        return {
            ROLE_OPTIONS,
            AUTHORITY_OPTIONS,
            STATUS_OPTIONS,
            loading: false,
            id: this.$route.query.id,
            form: initForm(),
            configForm: configFormEmployee(),
            chatworkTokenShow: '',
            listDataMasterTeam: [],
            listDataMasterGroup: [],
            listDataMasterRoles: [],
            isTeam: true,
            inValidToken: false,
            chatworkTokenTemp: null,
            isWaitToken: false,
            isInputAccountID: false,
            objTemp: {
                chatwork_token: '',
                account_id: null,
                chatwork_id: ''
            },
            isVerifyToken: false,
            hasButtonCheckToken: true,
            phoneSettingType: PHONE_SETTING_EMPLOYEE
        };
    },

    beforeRouteUpdate(to, from, next) {
        const queryId = to.query.id;
        if (!queryId) {
            this.resetForm();
        }
        next();
    },
    mounted() {
        this.getListMasterGroup();
        this.getListMasterRoles();
    },

    methods: {
        checkPermission,
        ...masterMethods,
        ...employeeMethods,
        ...settingPhoneMethods,
        ...authFackMethods,

        resetForm() {
            this.id = null;
            this.form = initForm();
            this.chatworkTokenShow = '';
            this.isInputAccountID = false;
            this.objTemp = {
                chatwork_token: '',
                account_id: null,
                chatwork_id: ''
            };
        },

        checkPermiss(listRole) {
            return checkPermissionName(listRole);
        },

        getListMasterRoles() {
            this.listMaster('roles').then((data) => {
                if (!data || data.length <= 0) return;
                this.listDataMasterRoles = data
                    .map((item) => {
                        item.text = NAMEROLEFIXED.find((o) => o.id === item.id)?.text ?? '';
                        return item;
                    })
                    .filter((role) => !role.name.includes('partner'));
            });
        },

        getListMasterGroup() {
            this.listMaster(keyMaster['employee.department']).then((data) => {
                this.listDataMasterGroup = data;
                this.listDataMasterTeam = data[1]?.data || [];
            });
        },

        getDetail(id) {
            this.loading = true;
            this.detailEmployee(id).then((data) => {
                this.form = {
                    ...this.form,
                    ...data,
                    phone_setting_type: data.phone_setting_type?.map((x) => x.type) ?? [],
                    role_id: data?.role?.id || null
                };
                this.objTemp = {
                    chatwork_token: data.chatwork_token,
                    account_id: data.account_id,
                    chatwork_id: data.chatwork_id
                };
                if (data.chatwork_token) {
                    this.chatworkTokenShow = data.chatwork_token;
                    this.isInputAccountID = true;
                } else {
                    this.chatworkTokenShow = '';
                    this.isInputAccountID = false;
                }
                // setTimeout(() => {
                //     this.setTeam();
                // }, 300);
                this.configForm.password.typesValidate = ['max255', 'password'];
                this.handleChangeType('mounted');
                this.loading = false;
            });
        },

        register() {
            if (this.loading) return;
            this.loading = true;
            let dataObject = cleanConfigFormData(this.form);
            dataObject.role = { id: dataObject.role_id };
            delete dataObject.role_id;
            dataObject.account_id = dataObject?.account_id ? Number(dataObject.account_id) : null;
            if (this.$route.query.id) {
                if (dataObject.team) dataObject.team = { id: dataObject.team.id };

                if (!dataObject.password) {
                    delete dataObject.password;
                }
                if (dataObject.chatwork_token === this.chatworkTokenShow) {
                    delete dataObject.chatwork_token;
                }
                if (!this.checkPermission('employee.edit')) {
                    this.$router.push({ path: '/employees' }).then(() => {
                        showMessage(8080, this.$bvToast, 'アクセス権限がありません。');
                    });
                } else {
                    this.updateEmployee(dataObject).then((data) => {
                        if (data.code == 200) {
                            showMessage(data.code, this.$bvToast, 'パルディア社員が更新されました。');
                            this.getDetail(this.$route.query.id);
                            this.form.password = null;
                            if (this.$route.query.id == state.user.id) this.profile();
                        } else {
                            showMessage(data.code, this.$bvToast, this.$t(data.message));
                            this.loading = false;
                        }
                    });
                }
            } else {
                if (!this.checkPermission('employee.register')) {
                    this.$router.push({ path: '/employees' }).then(() => {
                        showMessage(8080, this.$bvToast, 'パルディア社員が更新されました。');
                    });
                } else {
                    this.registerEmployee(dataObject).then((data) => {
                        if (data.code == 200) {
                            this.$router
                                .push({
                                    path: '/employee/view',
                                    query: {
                                        id: data.data.id
                                    }
                                })
                                .then(() => {
                                    showMessage(data.code, this.$bvToast, 'パルディア社員が登録されました。');
                                });
                        } else {
                            showMessage(data.code, this.$bvToast, this.$t(data.message));
                        }
                        this.loading = false;
                    });
                }
            }
        },

        formSubmit() {
            let check = validateAllField(this.form, this.configForm);
            if (this.isVerifyToken) {
                showMessage(8080, this.$bvToast, this.$t('pageEmployee.verifyToken'));
            }
            if (this.inValidToken || this.isVerifyToken || !check) {
                return;
            } else {
                this.register();
            }
        },
        goToEdit(path, id) {
            this.$router.push({ path: path, query: { id: id } });
        },

        // setTeam() {
        //     this.isTeam = false;
        //     this.listDataMasterTeam = [];
        //     let i = this.listDataMasterRoles.findIndex((x) => x.id == this.form.role?.id);
        //     if (i >= 0) {
        //         this.form.role.name = this.listDataMasterRoles[i].name;
        //         if (this.form.role?.name === 'sale') {
        //             let index = this.listDataMasterGroup.findIndex((x) => x.id == process.env.VUE_APP_SALE);
        //             if (index >= 0) this.listDataMasterTeam = this.listDataMasterGroup[index].data;
        //             this.isTeam = true;
        //         } else if (this.form.role?.name === 'instructor') {
        //             let index = this.listDataMasterGroup.findIndex((x) => x.id == process.env.VUE_APP_INSTRUCTOR);
        //             if (index >= 0) this.listDataMasterTeam = this.listDataMasterGroup[index].data;
        //             this.isTeam = true;
        //         }
        //     }
        // },
        // handleChangeSetTeam() {
        //     this.isTeam = false;
        //     this.listDataMasterTeam = [];
        //     this.form.team = null;
        //     let i = this.listDataMasterRoles.findIndex((x) => x.id == this.form.role?.id);
        //     if (i >= 0) {
        //         this.form.role.name = this.listDataMasterRoles[i].name;
        //         if (this.form.role?.name === 'sale') {
        //             let index = this.listDataMasterGroup.findIndex((x) => x.id == process.env.VUE_APP_SALE);
        //             if (index >= 0) this.listDataMasterTeam = this.listDataMasterGroup[index].data;
        //             this.isTeam = true;
        //         } else if (this.form.role?.name === 'instructor') {
        //             let index = this.listDataMasterGroup.findIndex((x) => x.id == process.env.VUE_APP_INSTRUCTOR);
        //             if (index >= 0) this.listDataMasterTeam = this.listDataMasterGroup[index].data;
        //             this.isTeam = true;
        //         }
        //     }
        // },

        handleRemoveSetTeam() {
            this.handleValidateField(this.form.role_id, this.configForm.role_id);
            this.listDataMasterTeam = [];
            this.form.team = null;
        },

        handleCallChatWork() {
            if ((this.chatworkTokenTemp && this.chatworkTokenTemp === this.form.chatwork_token) || !this.form.chatwork_token) return;
            this.chatworkTokenTemp = this.form.chatwork_token;
            let chatwork_token = this.form.chatwork_token;
            this.isWaitToken = false;
            this.getInfoChatWork({ chatwork_token })
                .then((res) => {
                    this.isWaitToken = false;
                    this.isVerifyToken = false;
                    if (!res) {
                        this.inValidToken = true;
                        this.form.account_id = null;
                        this.form.chatwork_id = '';
                        this.configForm.chatwork_token.error = true;
                        return;
                    }
                    this.inValidToken = false;
                    this.form.account_id = res?.account_id ?? null;
                    this.form.chatwork_id = res?.chatwork_id ?? '';
                    this.objTemp = {
                        account_id: res?.account_id ?? null,
                        chatwork_id: res?.chatwork_id ?? ''
                    };
                })
                .catch((error) => {
                    this.isWaitToken = false;
                    console.log('error', error);
                });
        },

        handleInputChatWorkToken() {
            this.inValidToken = false;
            if (!this.form.chatwork_token) {
                this.isVerifyToken = false;
                this.isInputAccountID = false;
                this.hasButtonCheckToken = true;
                this.form.account_id = null;
                this.form.chatwork_id = '';
            } else {
                this.isInputAccountID = true;
                this.hasButtonCheckToken = false;
                if (this.form.chatwork_token !== this.chatworkTokenTemp) {
                    this.form.account_id = null;
                    this.form.chatwork_id = '';
                    this.isVerifyToken = true;
                } else {
                    this.form.account_id = this.objTemp.account_id;
                    this.form.chatwork_id = this.objTemp.chatwork_id;
                    this.isVerifyToken = false;
                }
            }
        },

        handleValidateField(fieldValue, configField) {
            validateField(fieldValue, configField);
        },

        handleGetDetail() {
            this.$router.push({
                path: '/employee/view',
                query: {
                    id: this.$route.query.id
                }
            });
        },

        handleChangeType(type = 'select') {
            if (this.form.type == 1) {
                if (type == 'select') {
                    this.form.role_id = null;
                }
                this.configForm.role_id.typesValidate = ['requiredSelect'];
                this.configForm.team.typesValidate = ['requiredSelect'];
            } else {
                this.form.role_id = ID_ROLE_FIXED.PART_TIME;
                this.configForm.role_id.typesValidate = [];
                this.configForm.team.typesValidate = [];
            }
        }
    },
    watch: {
        '$route.query.id': {
            handler: function (val) {
                if (val) {
                    this.getDetail(val);
                }
            },
            immediate: true
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row form__body--card form__common--center" v-if="!loading">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-6">
                                <form class="needs-validation" @submit.prevent="formSubmit" autocomplete="off">
                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom01"
                                            >{{ $t('pageEmployee.name') }}<span class="text-danger">*</span></label
                                        >
                                        <div class="col-sm-12">
                                            <InputText
                                                id="name"
                                                :model.sync="form.name"
                                                :config.sync="configForm.name"
                                                @blur="handleValidateField(configForm.name)"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom02"
                                            >{{ $t('pageEmployee.name_kana') }}<span class="text-danger">*</span></label
                                        >
                                        <div class="col-sm-12">
                                            <InputText
                                                id="kana_name"
                                                :model.sync="form.kana_name"
                                                :config.sync="configForm.kana_name"
                                                @blur="handleValidateField(configForm.kana_name)"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom03"
                                            >{{ $t('pageEmployee.email') }}<span class="text-danger">*</span></label
                                        >
                                        <div class="col-sm-12">
                                            <InputText
                                                id="validationCustom03"
                                                :model.sync="form.email"
                                                :config.sync="configForm.email"
                                                @blur="handleValidateField(configForm.email)"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom04"
                                            >{{ $t('pageEmployee.password') }}<span class="text-danger">*</span>
                                        </label>

                                        <div class="col-sm-12">
                                            <InputText
                                                id="password"
                                                :model.sync="form.password"
                                                :config.sync="configForm.password"
                                                @blur="handleValidateField(configForm.password)"
                                            />
                                            <div>
                                                <small v-if="this.$route.query.id && !configForm.password.error" style="font-size: 14px">{{
                                                    $t('notificationCommon.notePass2')
                                                }}</small>
                                                <small v-else-if="!this.$route.query.id && !configForm.password.error">{{
                                                    $t('notificationCommon.notePass')
                                                }}</small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('pageEmployee.cellphoneNumber') }}</label>
                                        <div class="col-sm-12">
                                            <InputText
                                                id="phone_number"
                                                :model.sync="form.phone_number"
                                                :config.sync="configForm.phone_number"
                                                @blur="handleValidateField(configForm.phone_number)"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-3 mw--form" for="tokenUser">{{ $t('pageEmployee.tokenUser') }}</label>
                                        <div class="col-sm-12">
                                            <div class="d-flex">
                                                <div class="w-100">
                                                    <InputText
                                                        id="chatwork_token"
                                                        :model.sync="form.chatwork_token"
                                                        :config.sync="configForm.chatwork_token"
                                                        @input="handleInputChatWorkToken"
                                                        @blur="handleValidateField(configForm.chatwork_token)"
                                                    />
                                                    <span v-if="inValidToken" class="text-danger">{{ $t('tokenNotExist') }}</span>
                                                </div>
                                                <div class="ml-3">
                                                    <b-button
                                                        :disabled="hasButtonCheckToken"
                                                        variant="success"
                                                        @click="handleCallChatWork"
                                                        :class="{
                                                            disabled_cursor: hasButtonCheckToken
                                                        }"
                                                        style="white-space: nowrap"
                                                        >{{ $t('btn.verify') }}</b-button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-3 mw--form" for="accountId">{{ $t('pageEmployee.accountId') }}</label>
                                        <div class="col-sm-12">
                                            <InputText
                                                id="account_id"
                                                :model.sync="form.account_id"
                                                :config.sync="configForm.account_id"
                                                :disabled="isInputAccountID"
                                                @blur="handleValidateField(configForm.account_id)"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-3 mw--form" for="chatworkId">{{ $t('pageEmployee.chatworkId') }}</label>
                                        <div class="col-sm-12">
                                            <InputText
                                                id="chatwork_id"
                                                :model.sync="form.chatwork_id"
                                                :config.sync="configForm.chatwork_id"
                                                :disabled="isInputAccountID"
                                                @blur="handleValidateField(configForm.chatwork_id)"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-2 mw--form d-none d-sm-block" style="padding-right: 0">
                                            <hr />
                                        </div>
                                        <div class="col-sm-12" style="padding-left: 0">
                                            <hr />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom06">{{ $t('pageEmployee.statusAccount') }}</label>
                                        <div class="col-md-6 d-flex">
                                            <div v-for="itemStatus in STATUS_OPTIONS" :key="itemStatus.id + 'stt'">
                                                <InputRadio
                                                    class="mr-4"
                                                    :model.sync="form.status"
                                                    :name="`status_id-object`"
                                                    :id="`status_id-object-${itemStatus.id}`"
                                                    :value="itemStatus.id"
                                                    :label="itemStatus.text"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom06"
                                            >{{ $t('pageEmployee.type') }}<span class="text-danger">*</span></label
                                        >
                                        <div class="col-md-6 d-flex">
                                            <div v-for="itemRole in ROLE_OPTIONS" :key="itemRole.id + 'type'">
                                                <InputRadio
                                                    class="mr-4"
                                                    :model.sync="form.type"
                                                    :name="`type_id-object`"
                                                    :id="`type_id-object-${itemRole.id}`"
                                                    :value="itemRole.id"
                                                    :label="itemRole.text"
                                                    @change="handleChangeType('select')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="form.type === ROLE_OPTIONS[0].id">
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom06"
                                                >{{ $t('pageEmployee.role') }}<span class="text-danger">*</span></label
                                            >
                                            <div class="col-md-12">
                                                <div class="d-flex">
                                                    <div v-for="itemAuthority in AUTHORITY_OPTIONS" :key="itemAuthority.id + 'role'">
                                                        <InputRadio
                                                            class="mr-4 authority-radio"
                                                            :model.sync="form.role_id"
                                                            :name="`authority_id-object`"
                                                            :id="`authority_id-object-${itemAuthority.id}`"
                                                            :value="itemAuthority.id"
                                                            :label="itemAuthority.text"
                                                            :config.sync="configForm.role_id"
                                                        />
                                                    </div>
                                                </div>
                                                <div v-if="configForm.role_id.error" class="d-block invalid-feedback">
                                                    <span>
                                                        {{ $t('validateField.requiredSelect', { field: $t('pageEmployee.role') }) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom07"
                                                >{{ $t('pageEmployee.team') }}<span class="text-danger">*</span></label
                                            >
                                            <div class="col-md-6" style="min-width: 220px">
                                                <Multiselect
                                                    :id="`select-team_id-object`"
                                                    :value.sync="form.team"
                                                    :options="listDataMasterTeam"
                                                    :config.sync="configForm.team"
                                                    @remove="handleValidateField(form.team, configForm.team)"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom07">{{ $t('pageEmployee.roleSettingPhone') }}</label>
                                        <div class="col-md-6" style="min-width: 220px">
                                            <div v-for="(stp, k) in phoneSettingType" :key="k">
                                                <InputCheckBox
                                                    :model.sync="form.phone_setting_type"
                                                    :id="`check_phone_setting_type${k}`"
                                                    :value="stp.id"
                                                    :label="stp.label"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-sm-2 mw--form" for="validationCustom09">{{ $t('pageEmployee.description') }}</label>
                                        <div class="col-sm-12">
                                            <textarea rows="5" id="validationCustom09" v-model="form.note" class="form-control"></textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer>
                <div v-if="!id" class="d-flex justify-content-between">
                    <div class="text-center flex-fill">
                        <button
                            type="button"
                            class="btn btn-common-footer mr-3"
                            @click="
                                $router.push({
                                    path: '/employees'
                                })
                            "
                        >
                            {{ $t('btn.cancel') }}
                        </button>
                        <button
                            v-if="checkPermission('employee.register') || (checkPermission('employee.edit') && $route.query.id)"
                            type="submit"
                            @click="formSubmit"
                            class="btn btn-common btn-primary"
                            :disabled="isWaitToken"
                        >
                            <i class="ri-file-add-line"></i>{{ $t('btn.register') }}
                        </button>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="text-center flex-fill">
                            <button
                                type="button"
                                class="btn btn-common-footer mr-2"
                                @click="
                                    $router.push({
                                        path: '/employees'
                                    })
                                "
                            >
                                <i class="ri-file-list-2-line"></i>{{ $t('btn.backList') }}
                            </button>
                            <button type="submit " @click="handleGetDetail" class="btn btn-common btn-info" style="min-width: 76px">
                                <i class="ri-arrow-left-line"></i>{{ $t('btn.goToDetail') }}
                            </button>
                        </div>
                    </div>
                    <button
                        v-if="checkPermission('employee.register') || (checkPermission('employee.edit') && $route.query.id)"
                        type="submit"
                        @click="formSubmit"
                        class="btn btn-common btn-success"
                        :disabled="isWaitToken"
                    >
                        {{ $t('btn.save') }}
                    </button>
                </div>
            </Footer>
        </div>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>
<style lang="scss" scoped>
::v-deep .authority-radio label {
    white-space: pre-line;
}
</style>
